import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useViewModel from '../../../dashboard/viewmodels/list';

export const useGetTitle = () => {
  const [title, setTitle] = useState<string>('');
  const { dashboardData, actionGetDashboard } = useViewModel();
  const { dashboardList } = dashboardData;

  const hanldeTittle = (path: string) => {
    if (path === '' || path === 'report') {
      setTitle('');
    } else if (path === 'menu-items') {
      setTitle('Menu Item');
    } else {
      if (dashboardList) {
        const dataTitle = dashboardList.find((i) => i?.url === path);
        if (dataTitle) {
          setTitle(dataTitle.name);
        }
      }
    }
  };

  useEffect(() => {
    actionGetDashboard({ isActive: true });
  }, []);

  return { title, setTitle, hanldeTittle };
};
